














































































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import { GeneralSettingsData } from '@/types/campaign/settings';
import FieldMultipleSelect from '@/components/form/FieldMultipleSelect.vue';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { IChipsData } from '@/types';

export default Vue.extend({
  name: 'TheGeneralSettings',
  components: {
    WidgetWrapper,
    FieldInput,
    FieldMultipleSelect,
    SelectChipsFromRightSlide,
  },
  props: {
    data: {
      type: Object as PropType<GeneralSettingsData>,
      required: true,
    },
  },

  watch: {
    data(newValue) {
      this.campaign = newValue;
    },
  },

  computed: {
    ...mapGetters({
      offers: 'offerList',
      geoTargets: 'dictionary/getGeoTargets',
      category: 'categoryList',
    }),
    campaignGeo(): Array<string | number> {
      return this.campaign.geo_values.map((geo) => geo.value);
    },
  },

  methods: {
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeErrors(name) {
      this.campaign.errors[name] = [];
      this.$emit('changeErrors', name, this.campaign.errors[name]);
    },

    changeGeo(newGeo) {
      const geoValues = newGeo.map((geo) => geo);
      this.changeCampaign('geo_values', geoValues);
      this.changeErrors('geo_values');
    },
    async sendGeoRequest() {
      this.geoLoader = true;
      await this.$store.dispatch('dictionary/loadGeoTargets', this.filterGeo);
      this.geoLoader = false;
    },
    searchGeo: debounce(function (this: any, value) {
      this.filterGeo = value.trim();
      if (this.filterGeo) {
        this.sendGeoRequest();
      }
    }, 500),
    changeTypeGeo(value) {
      if (!this.campaign.geo_values?.length) return;

      this.campaign.geo_type = value;
      this.changeCampaign('geo_type', this.campaign.geo_type);
    },
    changeAdvertisingCategory(advertisingCategory) {
      this.campaign.advertising_category = advertisingCategory.map((ac) => ac);
      this.changeCampaign(
        'advertising_category',
        this.campaign.advertising_category
      );
    },
  },

  data() {
    return {
      campaign: this.data,
      filterGeo: '',
      geoLoader: false,
      advertisingCategory: [] as Array<IChipsData>,
    };
  },
});
